import { Box, Typography, Grid, Divider } from "@mui/material";
import FadeInBox from "../../commonComponents/FadeInBox";
import { services } from "../../constants/services";
const Services = () => {
  return (
    <Box
      sx={{
        ml: { xs: 2, md: 15 },
        mr: { xs: 2, md: 15 },
        mt: { xs: 5, md: 2 },
        mb: 5,
      }}
    >
      <Typography
        component="h1"
        sx={{
          fontWeight: 700,
          fontSize: { xs: "23px", md: "28px" },
          color: "#164B7C",
          fontFamily: "Montserrat",
          textAlign: { xs: "center", md: "inherit" },
          marginBottom: 5,
        }}
      >
        Our services
      </Typography>

      <ServicesList />
    </Box>
  );
};
export default Services;

// Component with fade-in for title and description
const ServiceTitleWithDescription = ({ title, description }) => {
  return (
    <>
      <FadeInBox
        delay={0}
        duration={1.2}
        translateY={20}
        triggerOnScroll={true}
        triggerOnMount={false}
      >
        <Typography
          style={{
            fontFamily: "Montserrat",
            fontSize: "25px",
            color: "#164B7C",
            fontWeight: 600,
            marginBottom: 5,
          }}
        >
          {title}
        </Typography>
      </FadeInBox>
      <Divider
        style={{
          backgroundColor: "#164B7C",
          width: 65,
          padding: 1,
          marginBottom: 20,
        }}
      />
      <FadeInBox
        delay={0.4}
        duration={1.2}
        translateY={20}
        triggerOnScroll={true}
        triggerOnMount={false}
      >
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "20px",
            fontWeight: 400,
            whiteSpace: "pre-line",
          }}
        >
          {description}
        </Typography>
      </FadeInBox>
    </>
  );
};

const ServicesList = () => {
  return services.map((service, index) => {
    const isEven = index % 2 === 0;

    const textGrid = (
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          textAlign: "start",
          justifyContent: "center",
          padding: { xs: "16px !important", md: "32px !important" },
        }}
      >
        <ServiceTitleWithDescription
          title={service.title}
          description={service.description}
        />
      </Grid>
    );

    const imageGridDesktop = (
      <Grid
        item
        xs={12}
        md={6}
        className="image-grid-item"
        sx={{
          display: { xs: "none", sm: "block" },
          padding: "0 !important",
          margin: "0 !important",
        }}
      >
        <img
          src={service.image}
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            margin: 0,
            padding: 0,
          }}
          alt={service.title}
        />
      </Grid>
    );

    const imageGridMobile = (
      <Grid
        item
        xs={12}
        md={6}
        className="image-grid-item"
        sx={{
          display: { sm: "none" },
          padding: "0 !important",
          margin: "0 !important",
        }}
      >
        <img
          src={service.image}
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            margin: 0,
            padding: 0,
          }}
          alt={service.title}
        />
      </Grid>
    );

    return (
      <FadeInBox
        key={index}
        delay={index * 0.2}
        triggerOnScroll={true}
        triggerOnMount={false}
      >
        <Box>
          <Grid
            container
            spacing={0}
            sx={{
              margin: 0,
              padding: 0,
              "& .image-grid-item": {
                padding: "0 !important",
                margin: "0 !important",
              },
            }}
          >
            {isEven ? (
              <>
                {imageGridDesktop}
                {textGrid}
                {imageGridMobile}
              </>
            ) : (
              <>
                {textGrid}
                {imageGridDesktop}
                {imageGridMobile}
              </>
            )}
          </Grid>
        </Box>
      </FadeInBox>
    );
  });
};
